import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';

import RetakeButton from '../course-retake/RetakeButton';
import messages from '../messages';

const CourseRetake = ({ courseId, intl }) => (
  <div className=" mb-3">
    <div className="">
      <h3 className="h5 mb-0">{intl.formatMessage(messages.courseRetakeTitle)}</h3>
      <div className="small text-muted">
        {intl.formatMessage(messages.courseRetakeWarning)}
      </div>

    </div>
    {/* <div className="card-body">
      <RetakeButton courseId={courseId} />
    </div> */}

    <ul class="list-unstyled">
      <li class="small">
        <RetakeButton courseId={courseId} />

      </li>
    </ul>
  </div>
);

CourseRetake.propTypes = {
  courseId: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(CourseRetake);
